export default {
	enterprises_index: ({ enterprises_index }) => {
		return enterprises_index;
	},
};
